const LOCA_STOGARE_ITEM_NAME = 'wislist-handles';
class WishList {
  constructor() {}

  getAllHandles = () => {
    const rawData = localStorage.getItem(LOCA_STOGARE_ITEM_NAME);

    if (rawData === null) {
      return [];
    }

    try {
      return JSON.parse(rawData) || [];
    } catch (e) {
      return [];
    }
  };

  addNewItem = (handle) => {
    const wishList = this.getAllHandles();
    const isHandleOnList = wishList.some((wishHandle) => wishHandle == handle);

    if (isHandleOnList) {
      return true;
    }

    try {
      wishList.push(handle);
      localStorage.setItem(LOCA_STOGARE_ITEM_NAME, JSON.stringify(wishList));

      return true;
    } catch (e) {
      return false;
    }
  };

  isItem = (handle) => {
    const wishList = this.getAllHandles();
    const isHandleOnList = wishList.some((wishHandle) => wishHandle == handle);

    return isHandleOnList;
  };

  removeItem = (handle) => {
    const wishList = this.getAllHandles();
    const newWishlist = wishList.filter((wishHandle) => wishHandle !== handle);
    localStorage.setItem(LOCA_STOGARE_ITEM_NAME, JSON.stringify(newWishlist));
    return true;
  };
}

class WishListBtn extends HTMLElement {
  constructor() {
    super();
    this.wishList = new WishList();
    this.btn = this.querySelector('.wish-list-add');
    this.btn.addEventListener('click', this.handleOnClick);
    this.texts = {
      primary: this.getAttribute('data-primary-text'),
      secondary: this.getAttribute('data-secondary-text'),
    };
    this.isItem = false;
    this.productGridItem = null;
    this.icon = this.querySelector('.icon');
    this.checkHandle();
    this.timeOut = null;
  }

  setProductItem = (item) => {
    this.productGridItem = item;
  };

  checkHandle = () => {
    const productHandle = this.btn?.getAttribute('data-product-handle');
    this.isItem = this.wishList.isItem(productHandle);

    if (this.isItem) {
      this.icon.classList.add('icon-active');
    } else {
      this.icon.classList.remove('icon-active');
    }

    if (this.btn.classList.contains('btn')) {
      const btnDiv = this.btn.querySelector('div');
      if (btnDiv) {
        btnDiv.innerHTML = this.isItem
          ? this.texts.secondary
          : this.texts.primary;
      }
    }
  };

  updateBannerState = (show) => {
    if (!this.productGridItem) {
      return;
    }
    const bannerContainer = this.productGridItem.querySelector(
      '.grid-product__wishlist-banner',
    );

    if (!bannerContainer) {
      return;
    }

    if (show) {
      bannerContainer.classList.add('banner-active');
    } else {
      bannerContainer.classList.remove('banner-active');
    }
  };

  handleOnClick = (e) => {
    const el = e.currentTarget;
    if (el.classList.contains('btn')) {
      el.classList.add('btn--loading');
    }
    const productHandle = el?.getAttribute('data-product-handle');
    if (!productHandle) {
      return;
    }

    if (this.isItem) {
      this.wishList.removeItem(productHandle);
      this.icon.classList.remove('icon-active');
      this.isItem = false;

      if (el.classList.contains('btn')) {
        const btnDiv = el.querySelector('div');
        if (btnDiv) {
          btnDiv.innerHTML = this.texts.primary;
        }
      }

      if (this.productGridItem) {
        this.updateBannerState(true);
        this.timeOut = setTimeout(() => {
          this.productGridItem.remove();
          document.dispatchEvent(new CustomEvent('build:empty-wishlist'));
        }, 10000);
      }
    } else {
      this.wishList.addNewItem(productHandle);
      this.icon.classList.add('icon-active');
      this.isItem = true;

      if (el.classList.contains('btn')) {
        const btnDiv = el.querySelector('div');
        if (btnDiv) {
          btnDiv.innerHTML = this.texts.secondary;
        }
      }

      if (this.productGridItem) {
        this.updateBannerState(false);
        clearTimeout(this.timeOut);
      }
    }

    if (el.classList.contains('btn')) {
      setTimeout(() => el.classList.remove('btn--loading'), 500);
    }
  };
}

if (!customElements.get('wishlist-btn')) {
  customElements.define('wishlist-btn', WishListBtn);
}

const parseHTML = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  return doc.body.firstChild;
};

const getProductContainer = async (handle) => {
  const perRow = 4;
  const quickShop = false;
  try {
    const rawHtml = await fetch(
      `/products/${handle}?view=swatch&per_row=${perRow}&quick_shop_enable=${quickShop}&end`,
    ).then((res) => res.text());
    return parseHTML(rawHtml);
  } catch (e) {
    console.error(e);
    return null;
  }
};

const checkEmptyWishlist = () => {
  console.log('init');
  const wishListEmpty = document.querySelector('[data-empty-wishlist]');
  const wishListConector = new WishList();

  const handles = wishListConector.getAllHandles();
  if (wishListEmpty) {
    if (handles.length) {
      wishListEmpty.classList.add('hide');
    } else {
      wishListEmpty.classList.remove('hide');
    }
  }
};

const initWishlist = async () => {
  const wishListWrapper = document.querySelector('.wishlist-wrapper');
  const wishListEmpty = document.querySelector('[data-empty-wishlist]');

  if (!wishListWrapper) {
    return;
  }

  wishListWrapper.innerHTML = '';

  const wishListConector = new WishList();

  const handles = wishListConector.getAllHandles();

  const checkEmptyWishlist = () => {
    console.log('init');
    if (wishListEmpty) {
      if (handles.length) {
        wishListEmpty.classList.add('hide');
      } else {
        wishListEmpty.classList.remove('hide');
      }
    }
  };

  checkEmptyWishlist();

  handles.forEach(async (handle) => {
    const newProductContainer = await getProductContainer(handle);
    newProductContainer
      .querySelectorAll('image-element')
      .forEach((imageElement) => {
        imageElement.classList.add('aos-init', 'aos-animate');
      });
    newProductContainer
      .querySelectorAll('.quick-product__btn')
      .forEach((quickProductBtn) => {
        quickProductBtn.classList.remove('btn--not-ready');
      });
    wishListWrapper.appendChild(newProductContainer);
    newProductContainer
      ?.querySelector('wishlist-btn')
      ?.setProductItem(newProductContainer);
    theme.preloadProductModal(
      handle,
      newProductContainer.getAttribute('data-product-id'),
      null,
    );
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initWishlist();
});

document.addEventListener('build:empty-wishlist', () => {
  checkEmptyWishlist();
});
